import React from 'react';
import { Englishcca3to52024 } from '../views';
// import Englishcca3to52024  from 'views/Englishcca3to52024';
const ClassAssemblyPage = () => {
    return <Englishcca3to52024 />;
  };
  
  export default ClassAssemblyPage;